// extracted by mini-css-extract-plugin
export var fileUpload = "_f2-1";
export var modalButton = "_f2-0";